import * as React from 'react';

import {
  Edit,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
  useRecordContext,
  useTranslate,
} from 'react-admin';

import { ICategory } from '../../../types';
import { MyTranslatableInputs } from '../../../components/MyTranslatableInputs';

const Title = () => {
  const record = useRecordContext<ICategory>();
  const translate = useTranslate();
  return (
    <span>
      {translate('resources.categories.editText')}{' '}
      {record ? `"${record.name}"` : ''}
    </span>
  );
};

const CategoriesEdit = () => {
  const translate = useTranslate();

  return (
    <Edit title={<Title />}>
      <SimpleForm>
        <ReferenceInput
          source="section"
          label={translate('resources.categories.fields.section')}
          reference="sections"
          perPage={1000}
        >
          <SelectInput optionText="name" validate={[required()]} />
        </ReferenceInput>
        {/* <TextInput
          source="name"
          label={translate('resources.categories.fields.name')}
          validate={[required()]}
        /> */}
        <MyTranslatableInputs groupKey="name">
          <TextInput
            source="nameTranslated"
            label={translate('resources.categories.fields.name')}
            validate={[required()]}
          />
        </MyTranslatableInputs>
        <NumberInput
          source="order"
          label={translate('resources.categories.fields.order')}
          min={1}
          max={99}
          step={1}
          validate={[required()]}
          style={{ width: 160 }}
        />
      </SimpleForm>
    </Edit>
  );
};

export default CategoriesEdit;
